/* ==============================================
 * custom-properties.css
 * GENERATED FILE - DO NOT EDIT MANUALLY
 *
 * Source: client/web/client_modules/shells/react/components/tokens/
 * To regenerate: yarn generate:css-properties
 * ============================================== */

:root {
    /* Palette */
    --orange-dk: #bf4200;
    --orange: #fe5800;
    --orange-lt: #ffdecc;
    --orange-xlt: #faf0e6;
    --orange-bg: #fff0e9;
    --orange-attention: #ea7134;
    --grey-dk: #211712;
    --grey: #4d4540;
    --grey-lt: #7a7370;
    --grey-xlt: #d4d1cf;
    --icon-primary: #4d4540;
    --icon-primary-hovered: #211712;
    --icon-primary-action: #d4d1cf;
    --icon-primary-action-hovered: #61b2de;
    --icon-secondary: #d4d1cf;
    --icon-secondary-dk: #7a7370;
    --button-secondary: #ebe8e8;
    --button-secondary-dk: #dbd9d9;
    --form-border: #d4d1cf;
    --label: #4d4540;
    --black: #000000;
    --white: #ffffff;
    --off-white-dk: #ebe8e8;
    --off-white-md: #ebe8e8;
    --off-white: #f7f7f7;
    --off-white-transparent: rgba(247, 247, 247, 0);
    --zebra-stripe: #f7f7f7;
    --success-bg: #ecf9ef;
    --success: #0b8d6c;
    --info-bg: #eaf5fb;
    --info: #337da8;
    --warning-bg: #fff5e5;
    --warning: #ea7134;
    --alert-bg: #fff7f7;
    --alert: #bf2436;
    --report-green: #5ccf73;
    --report-red: #ff596b;
    --report-blue: #61b2de;
    --report-orange: #ff7833;
    --report-orange-bg: #fff7f5;
    --report-navy: #3d405c;
    --plum-dk: #3d3b8a;
    --plum: #3d3b8a;
    --plum-xlt: #e9e9f6;
    --plum-lt: #dbdbf2;
    --plum-bg: #e9e9f6;
    --plum-bg-dk: #acace1;
    --company: #514fb8;
    --onboarding-help-dk: #3d3b8a;
    --onboarding-help: #514fb8;
    --onboarding-help-lt: #7373c7;
    --ai-purple-pink-xxlt: #fbfaff;
    --ai-purple-pink-xlt: #f2eefb;
    --ai-purple-pink-lt: #e6ddf7;
    --ai-purple-pink-md: #e2a9ff;
    --ai-purple-pink: #bb97f6;
    --ai-purple-xlt: #a378f6;
    --ai-purple-lt: #8b5cf6;
    --ai-purple-md: #7744e1;
    --ai-purple-primary: #602bcc;
    --ai-purple-dk: #4d22a3;
    --navy-dk: #337da8;
    --navy: #337da8;
    --navy-bg: #f7fafc;
    --person: #337da8;
    --navy-lt: #d9edf7;
    --blue-dk: #337da8;
    --blue: #3b9ed7;
    --blue-lt: #d9edf7;
    --blue-xlt: #e8f4fa;
    --blue-bg: #d9edf7;
    --blue-bg-lt: #eff5f7;
    --nutshell-pro: #4f86c6;
    --ai-blue: #0c0f32;
    --ai-hover: #0a0d2b;
    --support: #3d3b8a;
    --support-hover: #292967;
    --green-dk: #2e9942;
    --green: #33c252;
    --lead: #2e9942;
    --lead-hovered: #0b8d6c;
    --green-lt: #d6f2de;
    --green-xlt: #e4f6e9;
    --green-bg: #f7fcf7;
    --rose-dk: #bf2436;
    --rose: #ff2e47;
    --rose-lt: #ffd6d9;
    --rose-xlt: #fff7f7;
    --red: #ff2e47;
    --red-lt: #ffd6d9;
    --sidebar-red: #0c0f33;
    --wallboard-red: #fff7f7;
    --product: #bd9633;
    --product-bg: #bd9633;
    --product-bg-hovered: #fac942;
    --brown-dk: #bd9633;
    --brown: #fff0c5;
    --brown-lt: #fff5d9;
    --yellow: #fac947;
    --yellow-lt: #fff5d9;
    --yellow-bg: #fffcf7;
    --dotcom-purple: #660347;
    --dotcom-teal: #62d4ca;
    --tiny-intro-login: #d9edf7;
    --tiny-intro-signup: #d9edf7;
    --tiny-intro-teal: #d9edf7;
    --tiny-intro-teal-transparent: rgba(217, 237, 247, 0);
    --tiny-intro-off-white: #d9edf7;
    --activity: #bf2436;
    --task: #bd9633;
    --focus-blue: #065289;
    --skeleton-grey: #f1f1f1;
    --tag-grey-lt: #ebe8e8;
    --tag-grey: #d4d1cf;
    --tag-grey-dk: #7a7370;
    --tag-red: #ffb2bb;
    --tag-red-lt: #ffe5e7;
    --tag-red-dk: #ff2e47;
    --tag-orange: #ffccb2;
    --tag-orange-lt: #ffeee5;
    --tag-orange-dk: #ff7833;
    --tag-yellow: #fde9b4;
    --tag-yellow-lt: #fff8e5;
    --tag-yellow-dk: #fac947;
    --tag-green: #c4eecc;
    --tag-green-lt: #ecf9ef;
    --tag-green-dk: #5ccf73;
    --tag-blue: #c0e0f2;
    --tag-blue-lt: #eaf5fb;
    --tag-blue-dk: #3b9ed7;
    --tag-purple: #c8c8e9;
    --tag-purple-lt: #ececf8;
    --tag-purple-dk: #7373c7;
    --navy-dk-new: #404372;
    --navy-lt-new: #5977a4;
    --navy-xlt-new: #94d1fe;
    --sidebar-secondary: #242854;
    --navy-bg-new: #333766;
    --navy-bg-active-new: #5c5f87;
    --secondary-sidebar-hover-blue: #3f4372;
    --rcfx-sidebar: #1c2c48;
    --rcfx-sidebar-hover: #1c293f;
    --rcfx-sidebar-primary-item: #142034;
    --rcfx-sidebar-active: #0c57ad;
    --secondary-sidebar-text: #9397ba;
    --quote-signature-orange: #e39138;
    --quote-toolbar-background: #222f3e;
    --quote-toolbar-button-background: #394452;
    --messenger-blue: #3b5998;
    --instagram-pink: #dd2a7b;
    --whatsapp-green: #25d366;
    --whatsapp-green-dk: #075e54;
    --zoom-blue: #0b5cff;
    --google-green: #05ac47;
    --teams-blue: #464eb8;
    --sidebar-list-loading: #333557;
    --placeholder: #a6a3a1;
    --sidebar-primary: #0c0f33;
    --sidebar-hovered: #cfcfd6;
    --list-selected: #e8f4fb;
    --modal-overlay: hsla(234, 18%, 25%, 0.67);
    --flash-banner-error-text: hsl(353, 68%, 45%);
    --flash-banner-error-background: hsl(356, 100%, 92%);
    --social-twitter: #00aced;
    --social-linkedin: #007bb6;
    --social-foursquare: #ef4b78;
    --social-pinterest: #cb2027;
    --social-youtube: #e52d27;
    --social-flickr: #ff0084;
    --social-vimeo: #aad450;
    --social-google-plus: #dd4b39;
    --social-tumblr: #35465c;
    --social-dribbble: #ea4c89;
    --social-behance: #1769ff;
    --social-delicious: #3399ff;
    --social-hacker-news: #ff6600;
    --social-instagram: #3f729b;
    --social-lastfm: #c3000d;
    --social-reddit: #ff4500;
    --social-twitch: #6441a5;
    --social-vine: #00b488;

    /* Semantic Colors */
    --ai-purple-bg: var(--ai-purple-pink-xxlt);
    --ai-purple-border: var(--ai-purple-xlt);
    --ai-purple-box-shadow: var(--ai-purple-pink-lt);
    --ai-purple-gradient-basic-one: var(--ai-purple-lt);
    --ai-purple-gradient-basic-two: var(--ai-purple-primary);
    --ai-purple-gradient-one: var(--ai-purple-pink);
    --ai-purple-gradient-two: var(--ai-purple-lt);
    --ai-purple-gradient-three: var(--ai-purple-primary);
    --ai-purple-gradient-expanded-one: var(--ai-purple-pink-md);
    --ai-purple-gradient-expanded-two: var(--ai-purple-pink);
    --ai-purple-gradient-expanded-three: var(--ai-purple-lt);
    --ai-purple-gradient-expanded-four: var(--ai-purple-primary);
    --ai-purple-gradient-bold-one: var(--ai-purple-pink-md);
    --ai-purple-gradient-bold-two: var(--ai-purple-md);
    --ai-purple-gradient-bold-three: var(--ai-purple-lt);
    --ai-purple-gradient-bold-four: var(--ai-purple-pink-md);
    --ai-purple-gradient-bold-five: var(--ai-purple-lt);
    --ai-purple-gradient-bold-six: var(--ai-purple-md);
    --list-hovered: var(--blue-bg);
    --overdue: var(--rose-dk);
    --error: var(--rose);
    --warning: var(--orange-dk);
    --text-hot: var(--orange);
    --text-accounts: var(--plum-dk);
    --text-contacts: var(--navy-dk);
    --text-users: var(--orange-dk);
    --background-hot: var(--orange);
    --banner-border-orange: var(--orange-attention);
    --upgrade: var(--sidebar-primary);
    --social-facebook: var(--messenger-blue);
    --social-x: var(--black);
    --social-angel-list: var(--black);
    --social-digg: var(--black);
    --social-github: var(--black);

    /* Screen Sizes */
    --page-width: 940px;
    --page-content-width: 680px;
    --page-sidebar-width: 220px;
    --page-alternate-sidebar-width: 260px;
    --page-alternate-content-width: 640px;
    --sidebar-width: 202px;
    --nm-sidebar-width: 420px;
    --header-height: 50px;
    --onboard-progress-height-lg: 98px;
    --onboard-progress-height-md: 81px;
    --onboard-progress-height-sm: 69px;
    --screen-xs-max: 767px;
    --screen-sm-min: 768px;
    --screen-sm-max: 991px;
    --screen-md-min: 992px;
    --screen-md-max: 1199px;
    --screen-lg-min: 1200px;
    --show-expanded-sidebar-width: 1200px;

    /* Component Sizes */
    --filter-drawer-width: 220px;
    --report-sidebar-width: 140px;
    --report-container-margin-left: 16px;

    /* Font Sizes */
    --font-huge: 21px;
    --font-big: 17px;
    --font-normal: 15px;
    --font-small: 13px;
    --font-tiny: 12px;

    /* Borders */
    --border-hairline: 1px solid #f1f1f1;

    /* Easing */
    --custom-easing: cubic-bezier(0.23, 1, 0.32, 1);
    --custom-easing-bounce: cubic-bezier(0.175, 0.885, 0.32, 1.275);
    --custom-easing-bounce-short: cubic-bezier(0.18, 0.89, 0.45, 1.06);
}
